import { STATE_NAME } from "./busyIndicator.constants";

export const isBusy = state => state[STATE_NAME].busyCount > 0;

export const getIsInProcess = state => path =>
  state[STATE_NAME].stepsInProcess &&
  state[STATE_NAME].stepsInProcess.includes(path);
